import { LogMessageWithMeta } from 'types/logging/meta-log.type';
import { LogLevel } from '@sanlam-glacier/app-common/modules/logger';
import { CustomDevToolsMenuItem } from 'dev-tools';
import { Provider, atom, createStore } from 'jotai';
import { Env } from 'types';

// Create atoms here based on what you need in the store.
export const logLevel = atom(LogLevel.NONE);
export const currencyCountryCodeAtom = atom('ZAR');
export const googleApiKeyAtom = atom('');
export const currencyPrefixAtom = atom('R');
export const unavailableFundAtom = atom('Unavailable fund');
export const supportEmailAtom = atom('[placeholder]');
export const activeScenarioTabAtom = atom<string | undefined>(undefined);
export const minimumScreenSizeAtom = atom(798);
export const mobileBreakPoint = atom(1301);
export const logHistoryAtom = atom<LogMessageWithMeta[]>([]);
export const customDevToolAtom = atom<CustomDevToolsMenuItem | undefined>(undefined);
export const enableOptionsAndComparisons = atom(false);
// Store
export const jotaiStore = createStore();

// Set Store with atoms here
export const setJotaiStore = (environmentConfig: Env) => {
  jotaiStore.set(logLevel, environmentConfig.logLevel);
  jotaiStore.set(currencyCountryCodeAtom, environmentConfig.currencyCountryCode);
  jotaiStore.set(googleApiKeyAtom, environmentConfig.googleApiKey);
  jotaiStore.set(currencyPrefixAtom, environmentConfig.currencyPrefix);
  jotaiStore.set(unavailableFundAtom, environmentConfig.unavailableFund);
  jotaiStore.set(supportEmailAtom, environmentConfig.supportEmail);
  jotaiStore.set(
    enableOptionsAndComparisons,
    environmentConfig.featureFlags.enableOptionsAndComparisons
  );
};

export const JotaiProvider = Provider;
